export default __webpack_public_path__ + "static/media/kia.169e237e.png";